import React from 'react';
import { CheckCircle } from 'lucide-react'; // Optional: You can replace with an inline SVG if you don’t want to use Lucide

const SuccessToast = ({ message = "Congrats step got recorded" }) => {
    return (
        <div className="flex items-center gap-2.5 bg-[#ECFDF3] text-[#079455] px-3 py-1 rounded-md shadow-sm max-w-md">
            {/* Icon Circle */}
            <div className="flex items-center justify-center  rounded-full bg-green-100">
                <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 16.844C0 8.00747 7.16344 0.844025 16 0.844025V0.844025C24.8366 0.844025 32 8.00747 32 16.844V16.844C32 25.6806 24.8366 32.844 16 32.844V32.844C7.16344 32.844 0 25.6806 0 16.844V16.844Z" fill="#DCFAE6" />
                    <g clip-path="url(#clip0_7471_3259)">
                        <path d="M12.9999 16.844L14.9999 18.844L18.9999 14.844M22.6666 16.844C22.6666 20.5259 19.6818 23.5107 15.9999 23.5107C12.318 23.5107 9.33325 20.5259 9.33325 16.844C9.33325 13.1621 12.318 10.1774 15.9999 10.1774C19.6818 10.1774 22.6666 13.1621 22.6666 16.844Z" stroke="#079455" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7471_3259">
                            <rect width="16" height="16" fill="white" transform="translate(8 8.84402)" />
                        </clipPath>
                    </defs>
                </svg>

            </div>

            {/* Message */}
            <p className="font-semibold text-sm">{message}</p>
        </div>
    );
};

export default SuccessToast;
